import { render, staticRenderFns } from "./EventsListTable.vue?vue&type=template&id=c5849396&"
import script from "./EventsListTable.vue?vue&type=script&lang=ts&"
export * from "./EventsListTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./EventsListTable.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports